import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Upstox: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h2>Upstox API Setup in 7 Steps</h2>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 1</h2>
          <p>
            {/* Visit the Developer Apps page — Go to the Upstox Developer Apps page and navigate to the Analytics tab. */}
            Visit the Developer Apps page -- Go to the <b> Upstox Developer Apps</b>
            <br />
            <b>
              <a
                href="https://account.upstox.com/developer/apps#active"
                target="blank"
                title="Upstox Developer Apps"
              >
                https://account.upstox.com/developer/apps#active
              </a>
            </b>
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 2</h2>
          <p>
            Click
            {oneIndentation}
            <b>New App</b>
          </p>
          <img src="/images/broker_setup_guide/upstox/upstox_step_2.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 3</h2>
          <p>Fill the below details</p>

          <img src="/images/broker_setup_guide/upstox/upstox_step_3.png" alt="Quantman App details" />

          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>App Name:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="QUANTMAN" disabled />
                </span>
                <CopyTextButton text="QUANTMAN" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Redirect URL:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://www.quantman.trade/auth/upstox/callback" disabled />
                </span>
                <CopyTextButton text="https://www.quantman.trade/auth/upstox/callback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Primary IP</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Contact Support Team" disabled />
                </span>
                <CopyTextButton text="https://www.quantman.trade/Upstox/postback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Postback URL:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://www.quantman.trade/upstox/postback" disabled />
                </span>
                <CopyTextButton text="https://www.quantman.trade/upstox/postback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Description:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="QUANTMAN" disabled />
                </span>
                <CopyTextButton text="QUANTMAN" />
              </div>
            </div>
          </div>
        </div>
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 4</h2>
          <p>
            Please
            {oneIndentation}
            click <b>I accept the terms and conditions</b>
            {oneIndentation}
            and then click <b>Done</b>
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 5</h2>
          <p>
            Go to <strong>My Apps</strong> then click<strong>Algo Trading</strong>
            {oneIndentation}
            Then click <strong>Down Arrow</strong>
            {oneIndentation}
            <i className="fa-regular fa-circle-chevron-down tx-15 ms-2"></i>
          </p>
          <img src="/images/broker_setup_guide/upstox/upstox_step_5.png" alt="Quantman App details" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 6</h2>
          <img src="/images/broker_setup_guide/upstox/upstox_step_6.png" alt="Copy and paste api details" />
          <p>
            Now, you can Copy and paste <b>api key</b> and <b>api secret</b> in appropriate fields below.
          </p>
        </div>
      </li>
      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Upstox fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default Upstox;
